import { render } from "./SakitView.vue?vue&type=template&id=ad6ba4b8"
import script from "./SakitView.vue?vue&type=script&lang=js"
export * from "./SakitView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__